export class Config {

    private static instance: Config = null;

    static get(): Config {
        if (Config.instance == null) {
            Config.instance = new Config();
        }
        return Config.instance;
    }

    activeModules: string[];
    configuredModules: string[];

    isModuleConfigured(moduleName: string): boolean {
        return this.configuredModules?.includes(moduleName) ?? this.activeModules?.includes(moduleName) ?? false;
    }

}